import { CorrelatedStatsRestriction, getPickRestrictions } from "./get-pick-restrictions";
import { CompressedEventMarket } from "./types";

export type ComboValidationError =
	| { type: "duplicate-participant-in-event"; participant_id: string; event_id: string; error: Error }
	| { type: "correlated-stat-types"; stat_type_a: string; stat_type_b: string; error: Error };

export function validateComboPicks(
	picks: CompressedEventMarket[],
	correlated_stats: CorrelatedStatsRestriction[],
): ComboValidationError[] {
	if (picks.length === 0) return [];

	const errors: ComboValidationError[] = [];
	const pool: CompressedEventMarket[] = [];

	for (const pick of picks) {
		const restrictions = getPickRestrictions(pool, correlated_stats);

		const excluded_participants = restrictions.excluded_participants_by_event.get(pick.event_id);
		for (const participant_id of pick.participant_ids) {
			if (excluded_participants?.has(participant_id)) {
				errors.push({
					type: "duplicate-participant-in-event",
					participant_id,
					event_id: pick.event_id,
					error: new Error(`Market "${pick.title}" (${pick.id}) duplicates a participant already used in the same event`),
				});
			}
		}

		const excluded_stat_types = restrictions.excluded_stat_types_by_event.get(pick.event_id);
		if (excluded_stat_types?.has(pick.stat_type)) {
			const caused_by = correlated_stats.find(r =>
				(r.right_stat_type === pick.stat_type || r.left_stat_type === pick.stat_type) &&
				pool.some(p => p.event_id === pick.event_id && (p.stat_type === r.left_stat_type || p.stat_type === r.right_stat_type))
			);
			errors.push({
				type: "correlated-stat-types",
				stat_type_a: caused_by?.left_stat_type === pick.stat_type ? caused_by.right_stat_type : (caused_by?.left_stat_type ?? pick.stat_type),
				stat_type_b: pick.stat_type,
				error: new Error(`Market "${pick.title}" (${pick.id}) has a stat type correlated with another pick in the same event`),
			});
		}

		pool.push(pick);
	}

	return errors;
}
